export const MEDIA_NOW_PREFIX = '//media.now.hpe.com/EmbeddedPlayer.ashx?key=';
export const MEDIA_NOW_SUFFIX = '&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
